import React from "react";
import PropTypes from "prop-types";

export default function InfoIcon({
    width = 37,
    height = 36,
    className = "",
    ...props
}) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 37 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`info-icon ${className}`}
            {...props}
        >
            <g clipPath="url(#clip0_1_117558)">
                <path
                    d="M18.5039 3.1543C26.7011 3.1543 33.3535 9.80675 33.3535 18.0039C33.3535 26.2011 26.7011 32.8535 18.5039 32.8535C10.3067 32.8535 3.6543 26.2011 3.6543 18.0039C3.6543 9.80675 10.3067 3.1543 18.5039 3.1543ZM18.5039 5.85352C11.8061 5.85352 6.35352 11.3061 6.35352 18.0039C6.35352 24.7017 11.8061 30.1543 18.5039 30.1543C25.2017 30.1543 30.6543 24.7017 30.6543 18.0039C30.6543 11.3061 25.2017 5.85352 18.5039 5.85352ZM18.5039 16.6543C19.2461 16.6543 19.8535 17.2617 19.8535 18.0039V24.0039C19.8535 24.7461 19.2461 25.3535 18.5039 25.3535C17.7617 25.3535 17.1543 24.7461 17.1543 24.0039V18.0039C17.1543 17.2617 17.7617 16.6543 18.5039 16.6543ZM19.8535 10.6543V13.3535H17.1543V10.6543H19.8535Z"
                    fill="#E75330" stroke="white" strokeWidth="0.3" />
            </g>
            <defs>
                <clipPath id="clip0_1_117558">
                    <rect width="36" height="36" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}

InfoIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
};